import mixins from 'vue-typed-mixins';

import { HeaderInfo } from '@/interfaces/HeaderInfo';
import { eventBus } from '@/services/event-bus';
import { constants } from '@/shared/constants';
import { AccountTypes } from '@/shared/enums/AccountTypes';
import { ContractStatuses } from '@/shared/enums/ContractStatuses';
import { ServiceTypes } from '@/shared/enums/ServiceTypes';

export const interactsPermissions = mixins().extend({
	data() {
		return {
			eventsTypes: constants.eventsTypes,
			deactivatedStatuses: constants.deactivatedStatuses,
			contractStatuses: ContractStatuses,
			isRestricted: false as boolean,
			isDeactivated: false as boolean,
			serviceStatus: '' as string,
			contentInfo: {
				date: '',
				isPending: false
			}
		};
	},
	mounted() {
		eventBus.$on(this.eventsTypes.getHeaderInfo, this.setPermissionStatus);
	},
	destroyed() {
		eventBus.$off(this.eventsTypes.getHeaderInfo, this.setPermissionStatus);
	},
	methods: {
		setPermissionStatus(headerInfo: Partial<HeaderInfo>): void {
			if(headerInfo.status && headerInfo.type) {
				this.isRestricted = (headerInfo.status === AccountTypes.grace || headerInfo.status === AccountTypes.postGrace)
          && (headerInfo.type === ServiceTypes.MOBILE_PREPAID || headerInfo.type === ServiceTypes.MOBILE_PREPAID_DOPUNA_NET);
			}

			this.isDeactivated = this.deactivatedStatuses.includes(headerInfo.contractItemStatus) ||
				!!headerInfo.isTemporaryDeactivatedService ||
				!!headerInfo.occasionallyDeactivated ||
				headerInfo.contractItemStatus === ContractStatuses.needUpdate;

			if (headerInfo.contractItemStatus || headerInfo.isTemporaryDeactivatedService)
				this.serviceStatus = this.deactivatedStatuses.includes(headerInfo.contractItemStatus) ? this.contractStatuses.deactivated : '';

			if(headerInfo.contractItemStatus === ContractStatuses.needUpdate)
				this.serviceStatus = this.contractStatuses.dataUpdated;

			if (headerInfo.occasionallyDeactivated) {
				this.serviceStatus = headerInfo.occasionallyDeactivated ? this.contractStatuses.fixedOccasionallyDeactivated : '';
				this.contentInfo.isPending = headerInfo.inActivationProcess;
			}
		},
	},
});
